import { render, staticRenderFns } from "./tab16.vue?vue&type=template&id=3a7fbe78&"
import script from "./tab16.vue?vue&type=script&lang=js&"
export * from "./tab16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports